export const INDUSTRIES = [
    {
        id: "retail",
        name: "Retail & Shops",
        desc: "Storefront signage, shop branding, in-store displays and print material that pull customers in from the street.",
    },
    {
        id: "restaurants",
        name: "Restaurants & Cafés",
        desc: "Menus, food packaging, glow signs and social media creatives that make food businesses look as good as they taste.",
    },
    {
        id: "real-estate",
        name: "Real Estate",
        desc: "Project branding, brochures, site hoardings and walkthrough collateral that build buyer confidence.",
    },
    {
        id: "fmcg",
        name: "FMCG & Packaged Goods",
        desc: "Shelf-ready packaging, labels and carton design engineered to win the second look at retail.",
    },
    {
        id: "manufacturing",
        name: "Manufacturing",
        desc: "Corporate identity, product catalogues, exhibition stalls and factory signage for industrial businesses.",
    },
    {
        id: "corporate",
        name: "Corporate & Offices",
        desc: "Complete stationery systems, office branding, presentations and internal communication design.",
    },
    {
        id: "healthcare",
        name: "Healthcare & Clinics",
        desc: "Clean, trustworthy identity, clinic signage and patient-facing print material for doctors and hospitals.",
    },
    {
        id: "education",
        name: "Education & Coaching",
        desc: "Institute branding, prospectuses, admission campaign creatives and campus signage.",
    },
    {
        id: "events",
        name: "Events & Weddings",
        desc: "Invitations, backdrops, standees and complete event branding delivered on tight timelines.",
    },
    {
        id: "startups",
        name: "Startups & Local Businesses",
        desc: "Founder-friendly brand packages that make a new business look established from day one.",
    },
];

export default INDUSTRIES;
